import image1 from "../images/Gallery/brooklynBridge.jpg";
import image2 from "../images/Gallery/chinatown.jpg";
import image3 from "../images/Gallery/chineseFood.jpg";
import image4 from "../images/Gallery/nyc-1.jpg";
import image5 from "../images/Gallery/nyc-2.jpg";
import image6 from "../images/Gallery/nyc-3.jpg";
import image7 from "../images/Gallery/spaghetti.jpg";
import image8 from "../images/Gallery/spaghetti-2.jpg";
import image9 from "../images/Gallery/statueOfLiberty.jpg";
import image10 from "../images/Gallery/timesSquare-1.jpg";
import image11 from "../images/Gallery/timesSquare-2.jpg";

const imageGallery = [
  {
    image: image1,
    title: "Brooklyn Bridge",
  },
  {
    image: image2,
    title: "Chinatown",
  },
  {
    image: image3,
    title: "Chinese Noooooodles",
  },
  {
    image: image4,
    title: "New York City",
  },
  {
    image: image5,
    title: "New York City",
  },
  {
    image: image6,
    title: "New York City",
  },
  {
    image: image7,
    title: "Want me some spaghetti",
  },
  {
    image: image8,
    title: "Want me some more spaghetti",
  },
  {
    image: image9,
    title: "Statue of Liberty",
  },
  {
    image: image10,
    title: "Lighting up the City",
  },
  {
    image: image11,
    title: "Times Square",
  },
];

export default imageGallery;
